export const ventesFr = {
  rembourserEnLigne: 'Rembourser par le prestataire (test)',
  remboursementsEnLigne: 'Remboursements en ligne',
  paiementEnLigne: 'Paiement en ligne d’origine',
  remboursement_demande: 'En attente de confirmation',
  remboursement_confirme: 'Confirmé',
  remboursement_echoue: 'Échoué, montant libéré',
  remboursementTest:
    'Mode test uniquement. La confirmation dépend de la relecture du prestataire. Le coût reste à saisir par Venio.',
  a_regulariser: 'À régulariser',
  impayes_30: 'Impayés à 30 jours',
  emettreAvoir: 'Émettre un avoir',
  natureAvoir: 'Nature de l’avoir',
  avoirTotal: 'Total',
  avoirPartiel: 'Partiel',
  montantHt: 'Montant HT (€)',
  motifAvoir: 'Motif de l’avoir',
  preparerAvoir: 'Préparer l’avoir',
  confirmerAvoir: 'Confirmer l’avoir',
  modifierAvoir: 'Modifier',
  confirmationAvoir: 'Émettre une pièce définitive de {{montant}} TTC sur la facture {{numero}} ?',
  avoirSansDroit:
    'Le droit et la souscription restent inchangés. Tout remboursement est effectué par Venio hors Artosera.',
  avoirs: 'Avoirs TTC',
  resteDu: 'Reste dû TTC',
  aRembourser: '{{montant}} TTC à rembourser par Venio.',
  rembourser: 'Marquer un remboursement effectué',
  remboursements: 'Remboursements effectués',
  dateRemboursement: 'Date du remboursement',
  annulee: 'Annulée',
  emise: 'Émise',
  a_traiter: 'À traiter',
  suspendue: 'Suspendue',
  resiliee: 'Résiliée',
  close: 'Close',
  montantInvalide: 'Saisissez un montant en euros avec deux décimales au plus.',
  erreurs: {
    remboursement_excessif:
      'Le remboursement dépasse le trop-perçu restant. Vérifiez la facture actualisée.',
    avoir_excessif: 'Le cumul des avoirs dépasserait la facture.',
    excedent: 'Ce montant dépasse le reste dû. Un trop-perçu se traite hors de la facture.',
    revision_facture_perimee:
      'La facture a changé. Vérifiez les données actualisées avant de recommencer.',
    encaissement_deja_saisi: 'Cette référence bancaire a déjà été saisie sur cette facture.',
    mois_cloture: 'Le mois comptable est clôturé. Cette saisie ne peut pas être modifiée.',
    renvoi_impossible: 'Le PDF doit être disponible et le précédent envoi terminé ou en échec.',
    date_encaissement_invalide: 'La date doit être comprise entre l’émission et aujourd’hui.',
    journal_indisponible: 'Le journal est indisponible : rien n’a été changé.',
  },
  titre: 'Ventes d’add-ons',
  designation: 'Désignation',
  galerie: 'Galerie',
  montant: 'Montant',
  echeance: 'Échéance',
  etat: 'État',
  specimen: 'Spécimen',
  facture: 'Facture',
  commandes: 'Commandes',
  souscriptions: 'Souscriptions',
  factures: 'Factures',
  recurrent: 'Revenu mensuel récurrent HT',
  essais: 'Essais en cours',
  conversion: 'Conversion des essais clos (90 jours)',
  retard: 'Factures en retard',
  tests: 'Espaces de test',
  exclus: 'Exclus',
  seulementTests: 'Tests uniquement',
  tous: 'Tous',
  pages: 'Pagination',
  precedent: 'Précédent',
  suivant: 'Suivant',
  fermer: 'Fermer la facture',
  ht: 'HT',
  tva: 'TVA',
  ttc: 'TTC',
  regle: 'Réglé',
  envoi: 'Envoi',
  creance: 'Créance',
  telecharger: 'Télécharger le PDF',
  preparation: 'Facture en préparation',
  annuler: 'Annuler cet encaissement',
  saisir: 'Saisir un encaissement',
  encaisser: 'Encaisser',
  renvoyer: 'Renvoyer la facture',
  motif: 'Motif',
  confirmer: 'Confirmer',
  date: 'Date d’encaissement',
  montantTtc: 'Montant TTC (€)',
  reference: 'Référence bancaire',
  actualiser: 'Les données ont été actualisées. Vérifiez la facture avant de recommencer.',
  erreur: 'Ventes indisponibles. Rechargez la page.',
  chargement: 'Chargement des ventes…',
  a_payer: 'À payer',
  en_retard: 'En retard',
  reglee: 'Réglée',
  active: 'Active',
  partielle: 'Partielle',
  due: 'Due',
  a_envoyer: 'À envoyer',
  en_cours: 'Envoi en cours ou issue à vérifier',
  envoye: 'Envoyée',
  echec: 'Échec',
  normal: '20 %',
  autoliquidation: 'Autoliquidation',
  hors_ue: 'Hors champ',
  achat: 'Achat',
  essai: 'Essai',
  location_mensuelle: 'Location mensuelle',
  location_annuelle: 'Location annuelle',
  mensuelle: 'Mensuelle',
  annuelle: 'Annuelle',
};
export const ventesEn = {
  rembourserEnLigne: 'Refund through provider (test)',
  remboursementsEnLigne: 'Online refunds',
  paiementEnLigne: 'Original online payment',
  remboursement_demande: 'Awaiting confirmation',
  remboursement_confirme: 'Confirmed',
  remboursement_echoue: 'Failed, amount released',
  remboursementTest:
    'Test mode only. Confirmation requires reading the provider status. Venio must still record the cost.',
  a_regulariser: 'Needs reconciliation',
  impayes_30: 'Overdue by 30 days',
  emettreAvoir: 'Issue a credit note',
  natureAvoir: 'Credit note type',
  avoirTotal: 'Full',
  avoirPartiel: 'Partial',
  montantHt: 'Amount excluding VAT (€)',
  motifAvoir: 'Credit note reason',
  preparerAvoir: 'Prepare credit note',
  confirmerAvoir: 'Confirm credit note',
  modifierAvoir: 'Edit',
  confirmationAvoir:
    'Issue a final credit note of {{montant}} including VAT for invoice {{numero}}?',
  avoirSansDroit:
    'The entitlement and subscription remain unchanged. Venio handles any refund outside Artosera.',
  avoirs: 'Credits including VAT',
  resteDu: 'Balance due including VAT',
  aRembourser: '{{montant}} including VAT to be refunded by Venio outside Artosera.',
  rembourser: 'Record a completed refund',
  remboursements: 'Completed refunds',
  dateRemboursement: 'Refund date',
  annulee: 'Cancelled',
  emise: 'Issued',
  a_traiter: 'Needs attention',
  suspendue: 'Suspended',
  resiliee: 'Cancelled',
  close: 'Closed',
  montantInvalide: 'Enter an amount in euros with at most two decimal places.',
  erreurs: {
    remboursement_excessif:
      'The refund exceeds the remaining overpayment. Check the refreshed invoice.',
    avoir_excessif: 'The total credits would exceed the invoice.',
    excedent: 'This amount exceeds the balance due. Handle an overpayment outside the invoice.',
    revision_facture_perimee:
      'The invoice has changed. Check the refreshed data before trying again.',
    encaissement_deja_saisi: 'This bank reference has already been recorded on this invoice.',
    mois_cloture: 'The accounting month is closed. This receipt cannot be changed.',
    renvoi_impossible:
      'The PDF must be available and the previous delivery must be complete or failed.',
    date_encaissement_invalide: 'The date must be between issue date and today.',
    journal_indisponible: 'The audit journal is unavailable: nothing has changed.',
  },
  titre: 'Add-on sales',
  designation: 'Description',
  galerie: 'Gallery',
  montant: 'Amount',
  echeance: 'Due date',
  etat: 'Status',
  specimen: 'Specimen',
  facture: 'Invoice',
  commandes: 'Orders',
  souscriptions: 'Subscriptions',
  factures: 'Invoices',
  recurrent: 'Monthly recurring revenue excl. VAT',
  essais: 'Ongoing trials',
  conversion: 'Closed trial conversion (90 days)',
  retard: 'Overdue invoices',
  tests: 'Test spaces',
  exclus: 'Excluded',
  seulementTests: 'Test spaces only',
  tous: 'All',
  pages: 'Pagination',
  precedent: 'Previous',
  suivant: 'Next',
  fermer: 'Close invoice',
  ht: 'Excl. VAT',
  tva: 'VAT',
  ttc: 'Incl. VAT',
  regle: 'Paid',
  envoi: 'Delivery',
  creance: 'Receivable',
  telecharger: 'Download PDF',
  preparation: 'Invoice being prepared',
  annuler: 'Cancel this receipt',
  saisir: 'Record a receipt',
  encaisser: 'Record receipt',
  renvoyer: 'Resend invoice',
  motif: 'Reason',
  confirmer: 'Confirm',
  date: 'Receipt date',
  montantTtc: 'Amount incl. VAT (€)',
  reference: 'Bank reference',
  actualiser: 'The data has been refreshed. Check the invoice before trying again.',
  erreur: 'Sales unavailable. Reload this page.',
  chargement: 'Loading sales…',
  a_payer: 'To pay',
  en_retard: 'Overdue',
  reglee: 'Paid',
  active: 'Active',
  partielle: 'Partial',
  due: 'Due',
  a_envoyer: 'Pending',
  en_cours: 'Sending or outcome to verify',
  envoye: 'Sent',
  echec: 'Failed',
  normal: '20%',
  autoliquidation: 'Reverse charge',
  hors_ue: 'Out of scope',
  achat: 'Purchase',
  essai: 'Trial',
  location_mensuelle: 'Monthly rental',
  location_annuelle: 'Annual rental',
  mensuelle: 'Monthly',
  annuelle: 'Annual',
};
